if (!customElements.get('wls-main-product')) {
  class WLSMainProduct extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        hidden: 'hidden',
        loading: 'loading',
        disabled: 'disabled',
        selected: 'selected',
        isEmpty: 'is-empty',
        loadingSpinner: 'loading__spinner',
        variantId: 'input[name="id"]',
        sellingPlanId: 'input[name="selling_plan"]',
        quantity: 'input[name="quantity"]',
        optionValuesParam: 'option_values',
        optionGroup: 'js-buybox-option-group',
        optionInput: 'js-buybox-option-input',
        optionName: '[data-option-name]',
        optionValueId: '[data-value-id]',
        mainProductComponent: 'wls-main-product',
        errors: 'js-buybox-errors',
        errorMessage: 'js-error-message',
        productBuybox: 'js-wls-product-buybox',
        productGallery: 'js-wls-product-gallery',
        submitButton: '[type="submit"]',
        form: 'form[action="/cart/add"]',
        regularityInput: 'js-buybox-regularity-input',
        subscriptionFrequency: 'js-subscription-frequency',
        varietyPackLink: 'js-variety-pack-link',
        dropdownItemContent: 'js-dropdown-item-content',
        dropdownItem: 'js-dropdown-item',
        sellingPlanInput: 'js-selling-plan-input',
        buyboxVariants: 'js-buybox-variants',
        buyboxQuantity: 'js-buybox-quantity',
        buyboxAddToCartButton: 'js-buybox-add-to-cart-button',
        addToCartButtonPrice: 'js-add-to-cart-btn-price',
        addToCartButtonComparePrice: 'js-add-to-cart-btn-compare-price',
        subscriptionDiscount: 'js-subscription-discount',
        prevButton: 'js-swiper-btn-prev',
        nextButton: 'js-swiper-btn-next',
        pagination: 'js-custom-pagination',
        customNavigation: 'js-swiper-navigation',
        stickyButton: 'js-sticky-add-to-cart-button',
        stickyButtonWrapper: 'js-sticky-button-wrapper',
      };

      this.params = {
        optionValues: 'option_values',
      };

      this.selectors = this.getSelectors();

      this.currentState = {
        optionValues: {},
        variantId: null,
        sellingPlanId: null,
        isSubscription: false,
        quantity: 1,
      };

      this.currentVariant = null;
      this.productGallerySlider = null;
      this.updateURLTimeout = null;
    }

    getSelectors() {
      return {
        optionGroups: this.querySelectorAll(`.${this.classes.optionGroup}`),
        optionInputs: this.querySelectorAll(`.${this.classes.optionInput}`),
        errors: this.querySelector(`.${this.classes.errors}`),
        errorMessage: this.querySelector(`.${this.classes.errorMessage}`),
        quantity: this.querySelector(this.classes.quantity),
        productGallery: this.querySelector(`.${this.classes.productGallery}`),
        submitButton: this.querySelector(this.classes.submitButton),
        form: this.querySelector(this.classes.form),
        cart: document.querySelector('cart-notification') || document.querySelector('cart-drawer'),
        cartData: document.getElementById('CartData'),
        cartDataJSON: JSON.parse(document.getElementById('CartData').textContent),
        cartDrawer: document.getElementById('CartDrawer'),
        regularityInputs: this.querySelectorAll(`.${this.classes.regularityInput}`),
        subscriptionFrequency: this.querySelector(`.${this.classes.subscriptionFrequency}`),
        varietyPackLinks: this.querySelectorAll(`.${this.classes.varietyPackLink}`),
        sellingPlanInputs: this.querySelectorAll(`.${this.classes.sellingPlanInput}`),
        buyboxVariants: this.querySelector(`.${this.classes.buyboxVariants}`),
        buyboxQuantity: this.querySelector(`.${this.classes.buyboxQuantity}`),
        buyboxAddToCartButton: this.querySelector(`.${this.classes.buyboxAddToCartButton}`),
        productList: this.querySelector(`.${this.classes.productList}`),
        prevButton: this.querySelector(`.${this.classes.prevButton}`),
        nextButton: this.querySelector(`.${this.classes.nextButton}`),
        paginationElement: this.querySelector(`.${this.classes.pagination}`),
        customNavigation: this.querySelector(`.${this.classes.customNavigation}`),
        stickyButton: this.querySelector(`.${this.classes.stickyButton}`),
        stickyButtonWrapper: this.querySelector(`.${this.classes.stickyButtonWrapper}`),
      };
    }

    connectedCallback() {
      this.syncCurrentStateFromURL();
      this.bindEvents();
    }

    bindEvents() {
      const variantIdInput = this.querySelector(this.classes.variantId);

      this.initializeProductGallery();
      this.handleVarietyPackLinkState();

      this.selectors.optionInputs.forEach((input) => {
        if (input.hasAttribute('disabled')) return;
        input.addEventListener('change', this.handleOptionInputChange.bind(this));
      });
      this.selectors.regularityInputs.forEach((input) => {
        input.addEventListener('change', this.handleRegularityInputChange.bind(this));
      });
      this.selectors.sellingPlanInputs.forEach((input) => {
        input.addEventListener('change', (event) => this.handleSellingPlanChange(event.target));
      });
      if (this.selectors.quantity) {
        this.selectors.quantity.addEventListener('change', this.handleQuantityChange.bind(this));
      }
      this.selectors.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      if (variantIdInput) {
        this.currentState.variantId = variantIdInput.value;
        this.currentVariant = window.productVariants?.find(
          (variant) => variant.id.toString() === this.currentState.variantId
        );
        this.updatePrice();
      }

      // Bind sticky button events
      this.bindStickyButtonEvents();
    }

    initializeProductGallery() {
      if (this.productGallerySlider) {
        this.productGallerySlider.destroy();
        this.productGallerySlider = null;
      }
      const galleryElement = this.selectors.productGallery;
      if (galleryElement) {
        const mainSwiper = new Swiper(galleryElement, {
          spaceBetween: 0,
          loop: true,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: this.selectors.paginationElement,
            clickable: true,
            renderBullet: (index, className) => {
              return `
                        <span class="${className} slider-dot">
                            <svg width="9" height="9" viewBox="0 0 9 9" fill="none">
                                <path d="M4.4346 1.10409C4.46647 1.05886 4.53353 1.05886 4.5654 1.10409L4.91353 1.59827C5.07491 1.82737 5.37701 1.90831 5.63131 1.7906L6.17989 1.53669C6.2301 1.51345 6.28819 1.54698 6.29317 1.6021L6.34756 2.20413C6.37278 2.48322 6.59393 2.70437 6.87302 2.72959L7.47505 2.78398C7.53016 2.78896 7.5637 2.84704 7.54046 2.89726L7.28654 3.44584C7.16884 3.70014 7.24978 4.00224 7.47887 4.16362L7.97306 4.51175C8.01829 4.54361 8.01829 4.61068 7.97306 4.64255L7.47887 4.99067C7.24978 5.15206 7.16884 5.45415 7.28654 5.70846L7.54046 6.25704C7.5637 6.30725 7.53016 6.36534 7.47505 6.37032L6.87302 6.42471C6.59393 6.44993 6.37278 6.67108 6.34756 6.95017L6.29317 7.5522C6.28819 7.60731 6.2301 7.64085 6.17989 7.6176L5.63131 7.36369C5.37701 7.24598 5.07491 7.32693 4.91353 7.55602L4.5654 8.0502C4.53353 8.09544 4.46647 8.09544 4.4346 8.0502L4.08647 7.55602C3.92509 7.32693 3.62299 7.24599 3.36869 7.36369L2.82011 7.6176C2.7699 7.64085 2.71181 7.60731 2.70683 7.5522L2.65244 6.95017C2.62722 6.67108 2.40607 6.44993 2.12698 6.42471L1.52495 6.37032C1.46984 6.36534 1.4363 6.30725 1.45954 6.25704L1.71346 5.70846C1.83116 5.45415 1.75022 5.15206 1.52113 4.99067L1.02694 4.64255C0.981707 4.61068 0.981707 4.54361 1.02694 4.51175L1.52113 4.16362C1.75022 4.00224 1.83116 3.70014 1.71346 3.44584L1.45954 2.89726C1.4363 2.84704 1.46984 2.78896 1.52495 2.78398L2.12698 2.72959C2.40607 2.70437 2.62722 2.48322 2.65244 2.20413L2.70683 1.60209C2.71181 1.54698 2.7699 1.51345 2.82011 1.53669L3.36869 1.7906C3.62299 1.90831 3.92509 1.82737 4.08647 1.59827L4.4346 1.10409Z" fill="#010101" stroke="#010101" stroke-width="0.5"/>
                            </svg>
                        </span>
                    `;
            },
          },
          navigation: {
            prevEl: this.selectors.prevButton,
            nextEl: this.selectors.nextButton,
          },
          a11y: {
            enabled: true,
          },
        });
        if (!mainSwiper.isLocked) {
          this.selectors?.customNavigation?.classList.remove('slider-navigation-lock');
          this.selectors.nextButton?.classList.remove(this.classes.hidden);
          this.selectors.prevButton?.classList.remove(this.classes.hidden);
        } else {
          this.selectors?.customNavigation?.classList.add('slider-navigation-lock');
          this.selectors.nextButton?.classList.add(this.classes.hidden);
          this.selectors.prevButton?.classList.add(this.classes.hidden);
        }
        this.productGallerySlider = mainSwiper;
      }
    }

    handleVarietyPackLinkState() {
      this.selectors.varietyPackLinks.forEach((link) => {
        const href = link.getAttribute('href');
        const parentDropdownItem = link.closest(`.${this.classes.dropdownItem}`);
        if (href && window.location.pathname.includes(href) && parentDropdownItem) {
          parentDropdownItem?.classList.add(this.classes.selected);
        }
      });
    }

    handleRegularityInputChange(event) {
      const regularityInput = event.target;
      const regularityInputValue = regularityInput.value;
      if (regularityInputValue === 'subscription') {
        this.currentState.isSubscription = true;
        this.selectors.subscriptionFrequency.classList.remove(this.classes.hidden);
        // Select the first selling plan by default if none is selected
        const selectedSellingPlan = Array.from(this.selectors.sellingPlanInputs).find((input) => input.checked);
        if (!selectedSellingPlan && this.selectors.sellingPlanInputs.length > 0) {
          this.selectors.sellingPlanInputs[0].checked = true;
          const dropdownItem = this.selectors.sellingPlanInputs[0].closest(`.${this.classes.dropdownItem}`);
          if (dropdownItem) {
            dropdownItem.classList.add(this.classes.selected);
          }
          this.handleSellingPlanChange(this.selectors.sellingPlanInputs[0]);
        }
      } else {
        this.currentState.isSubscription = false;
        this.currentState.sellingPlanId = null;
        this.selectors.subscriptionFrequency.classList.add(this.classes.hidden);
        // Deselect all selling plan inputs
        this.selectors.sellingPlanInputs.forEach((input) => {
          input.checked = false;
          const dropdownItem = input.closest(`.${this.classes.dropdownItem}`);
          if (dropdownItem) {
            dropdownItem.classList.remove(this.classes.selected);
          }
        });
        // Update price to show one-time purchase price
        this.updatePrice();
      }
    }

    handleSellingPlanChange(sellingPlanInput) {
      const sellingPlanId = sellingPlanInput.value;
      this.currentState.sellingPlanId = sellingPlanId;
      this.updatePrice();
      this.updateSubscriptionDiscount();
    }

    handleQuantityChange(event) {
      const quantityInput = event.target;
      const newQuantity = parseInt(quantityInput.value);
      const maxQuantity = quantityInput.hasAttribute('data-max')
        ? parseInt(quantityInput.getAttribute('data-max'))
        : Infinity;

      // Ensure quantity doesn't exceed max
      if (newQuantity > maxQuantity) {
        quantityInput.value = maxQuantity;
        this.currentState.quantity = maxQuantity;
      } else {
        this.currentState.quantity = newQuantity;
      }

      // Update quantity buttons state
      this.updateQuantityButtonsState(quantityInput);

      // Update price based on new quantity
      this.updatePrice();
    }

    updateQuantityButtonsState(quantityInput) {
      const value = parseInt(quantityInput.value);
      const min = parseInt(quantityInput.getAttribute('min') || '1');
      const max = parseInt(quantityInput.getAttribute('data-max')) || Infinity;
      const cartQuantity = parseInt(quantityInput.getAttribute('data-cart-quantity')) || 0;

      const minusButton = quantityInput.parentElement?.querySelector('button[name="minus"]');
      const plusButton = quantityInput.parentElement?.querySelector('button[name="plus"]');

      if (minusButton) {
        minusButton.classList.toggle(this.classes.disabled, value <= min);
        minusButton.disabled = value <= min;
      }

      if (plusButton) {
        const isDisabled = value >= max || cartQuantity >= max;
        plusButton.classList.toggle(this.classes.disabled, isDisabled);
        plusButton.disabled = isDisabled;
      }

      // Update sticky button disabled state
      if (this.selectors.stickyButton) {
        const isDisabled = value >= max || cartQuantity >= max;
        this.selectors.stickyButton.classList.toggle(this.classes.disabled, isDisabled);
        this.selectors.stickyButton.disabled = isDisabled;
      }
    }

    updatePrice() {
      const variant = this.currentVariant;
      if (!variant) return;

      // Get base prices
      let price = variant.price;
      let compareAtPrice = variant.compare_at_price;

      // Apply subscription discount if applicable
      if (this.currentState.isSubscription && this.currentState.sellingPlanId) {
        const sellingPlanAllocation = variant.selling_plan_allocations.find((allocation) => {
          return `${allocation.selling_plan_id}` === this.currentState.sellingPlanId;
        });
        if (sellingPlanAllocation) {
          price = sellingPlanAllocation.price;
          compareAtPrice = sellingPlanAllocation.compare_at_price || variant.compare_at_price;
        }
      }

      // Apply quantity multiplier if quantity > 1
      const quantity = this.currentState.quantity || 1;
      if (quantity > 1) {
        price = price * quantity;
        if (compareAtPrice) {
          compareAtPrice = compareAtPrice * quantity;
        }
      }

      const priceElements = this.querySelectorAll(`.${this.classes.addToCartButtonPrice}`);
      const compareAtPriceElements = this.querySelectorAll(`.${this.classes.addToCartButtonComparePrice}`);
      this.updatePriceState(priceElements, compareAtPriceElements, price, compareAtPrice);
    }

    updatePriceState(priceElements, compareAtPriceElements, price, compareAtPrice) {
      if (priceElements.length > 0) {
        priceElements.forEach((priceElement) => {
          priceElement.innerHTML = this.formatMoney(price);
        });
      }

      if (compareAtPriceElements.length > 0) {
        if (compareAtPrice && compareAtPrice > price) {
          compareAtPriceElements.forEach((compareAtPriceElement) => {
            compareAtPriceElement.innerHTML = this.formatMoney(compareAtPrice);
            compareAtPriceElement.classList.remove(this.classes.hidden);
          });
        } else {
          compareAtPriceElements.forEach((compareAtPriceElement) => {
            compareAtPriceElement.classList.add(this.classes.hidden);
          });
        }
      }
    }

    async handleOptionInputChange(event) {
      const optionInput = event.target;
      const optionName = optionInput.name;
      const optionValueId = optionInput.dataset.valueId;
      this.currentState.optionValues[optionName] = optionValueId;

      this.setLoadingState();
      try {
        const url = this.generateURL();
        const response = await fetch(url);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Update specific sections
        await this.updateBuyboxSections(doc);

        // Update URL
        this.updateURL(url);
      } catch (error) {
        this.showError('An error occurred while updating the product. Please try again.');
      } finally {
        this.clearLoadingState();
      }
    }

    async updateBuyboxSections(doc) {
      // Update variants section
      const newVariantsSection = doc.querySelector(`.${this.classes.buyboxVariants}`);
      if (newVariantsSection && this.selectors.buyboxVariants) {
        this.selectors.buyboxVariants.innerHTML = newVariantsSection.innerHTML;
        // Rebind option input events
        this.selectors.optionInputs = this.querySelectorAll(`.${this.classes.optionInput}`);
        this.selectors.optionInputs.forEach((input) => {
          input.addEventListener('change', this.handleOptionInputChange.bind(this));
        });
      }

      // Update quantity section
      const newQuantitySection = doc.querySelector(`.${this.classes.buyboxQuantity}`);
      if (newQuantitySection && this.selectors.buyboxQuantity) {
        // Store current quantity before updating
        const quantityInput = this.selectors.quantity;
        if (quantityInput) {
          this.currentState.quantity = parseInt(quantityInput.value);
        }
        this.selectors.buyboxQuantity.innerHTML = newQuantitySection.innerHTML;
        // Update quantity input reference and its value
        this.selectors.quantity = this.selectors.buyboxQuantity.querySelector(`${this.classes.quantity}`);
        if (this.selectors.quantity) {
          const maxQuantity = this.selectors.quantity.hasAttribute('data-max')
            ? parseInt(this.selectors.quantity.getAttribute('data-max'))
            : Infinity;
          // Set quantity value based on state and max limit
          this.currentState.quantity =
            this.currentState.quantity > maxQuantity ? maxQuantity : this.currentState.quantity;
          this.selectors.quantity.value = this.currentState.quantity;
          // Add quantity change handler
          this.selectors.quantity.addEventListener('change', this.handleQuantityChange.bind(this));
          // Update quantity buttons state
          this.updateQuantityButtonsState(this.selectors.quantity);
        }
      }

      // Update add to cart button section
      const newAddToCartSection = doc.querySelector(`.${this.classes.buyboxAddToCartButton}`);
      if (newAddToCartSection && this.selectors.buyboxAddToCartButton) {
        this.selectors.buyboxAddToCartButton.innerHTML = newAddToCartSection.innerHTML;
        // Update submit button reference after content update
        this.selectors.submitButton = this.querySelector(this.classes.submitButton);
      }

      // Update sticky button section
      const newStickyButtonSection = doc.querySelector(`.${this.classes.stickyButtonWrapper}`);
      if (newStickyButtonSection && this.selectors.stickyButtonWrapper) {
        this.selectors.stickyButtonWrapper.innerHTML = newStickyButtonSection.innerHTML;
        // Update sticky button reference
        this.selectors.stickyButton = this.querySelector(`.${this.classes.stickyButton}`);
        // Rebind sticky button events after content update
        this.bindStickyButtonEvents();
      }

      // Update current variant and price
      const variantIdInput = this.querySelector(this.classes.variantId);
      if (variantIdInput) {
        this.currentState.variantId = variantIdInput.value;
        this.currentVariant = window.productVariants?.find(
          (variant) => variant.id.toString() === this.currentState.variantId
        );
      }

      // Update price based on current subscription state
      if (this.currentState.isSubscription && this.currentState.sellingPlanId) {
        const sellingPlanInput = this.querySelector(`input[value="${this.currentState.sellingPlanId}"]`);
        if (sellingPlanInput) {
          sellingPlanInput.checked = true;
          this.handleSellingPlanChange(sellingPlanInput);
        }
      } else {
        this.updatePrice();
      }
    }

    updateSubscriptionDiscount() {
      const discountElement = this.querySelector(`.${this.classes.subscriptionDiscount}`);
      if (!discountElement || !this.currentState.sellingPlanId) return;

      const sellingPlanInput = this.querySelector(
        `input[name="selling_plan"][value="${this.currentState.sellingPlanId}"]`
      );
      if (!sellingPlanInput) return;

      const rawAdjustments = sellingPlanInput.getAttribute('data-price-adjustments');
      if (!rawAdjustments) return;

      let adjustments = [];
      try {
        adjustments = JSON.parse(rawAdjustments);
      } catch (e) {
        console.warn('Invalid price adjustment JSON', e);
        return;
      }

      const adjustment = adjustments[0];
      if (!adjustment) return;

      if (adjustment.value_type === 'percentage') {
        discountElement.textContent = ` ${adjustment.value}%`;
      } else if (adjustment.value_type === 'amount') {
        discountElement.textContent = ` ${this.formatMoney(adjustment.value)}`;
      } else {
        discountElement.textContent = `SAVE`;
      }
    }

    syncCurrentStateFromURL() {
      const params = new URLSearchParams(window.location.search);
      const optionValues = params.get(this.params.optionValues);
      if (!optionValues) return;
      const currentOptionValuesFromURL = optionValues.split(',');
      this.currentState.optionValues = {};
      this.selectors.optionInputs.forEach((input) => {
        const valueId = input.dataset.valueId;
        if (currentOptionValuesFromURL.includes(valueId)) {
          this.currentState.optionValues[input.name] = valueId;
        }
      });
    }

    generateURL() {
      const params = new URLSearchParams(window.location.search);
      params.set(this.params.optionValues, Object.values(this.currentState.optionValues).join(','));
      return `${window.location.pathname}?${params.toString()}`;
    }

    updateURL(url, immediate = false) {
      // Clear any existing timeout
      if (this.updateURLTimeout) {
        clearTimeout(this.updateURLTimeout);
      }

      if (immediate) {
        // For immediate updates (like direct navigation), use replaceState
        window.history.replaceState({ path: url }, '', url);
      } else {
        // For filter changes, debounce the update
        this.updateURLTimeout = setTimeout(() => {
          window.history.replaceState({ path: url }, '', url);
        }, 500); // Wait 500ms before updating URL
      }
    }

    onSubmitHandler(event) {
      event.preventDefault();
      if (this.selectors.submitButton.hasAttribute(this.classes.disabled)) return;

      this.addButtonLoadingState(this.selectors.submitButton);

      // Update sticky button loading state
      if (this.selectors.stickyButton) {
        this.addButtonLoadingState(this.selectors.stickyButton);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      // Create form data and ensure quantity is set
      const formData = new FormData(this.selectors.form);

      if (this.currentState.quantity >= 1) {
        formData.set('quantity', this.currentState.quantity);
      }

      if (this.selectors.cart) {
        try {
          const sections = this.selectors.cart.getSectionsToRender();
          formData.append(
            'sections',
            sections.map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          // Only set active element if cart drawer exists and is accessible
          if (this.selectors.cartDrawer) {
            this.selectors.cart.setActiveElement(document.activeElement);
          }
        } catch (e) {
          console.warn('Error preparing cart data:', e);
        }
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.showError(response.description || response.message);
            return;
          } else if (!this.selectors.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          try {
            // Check if the cart drawer exists and is accessible
            if (!this.selectors.cartDrawer) {
              console.warn('Cart drawer element not found');
              window.location = window.routes.cart_url;
              return;
            }

            CartPerformance.measure('add:paint-updated-sections', () => {
              // First ensure the cart is not marked as empty
              this.selectors.cart.classList.remove(this.classes.isEmpty);
              // Then render the contents
              this.selectors.cart.renderContents(response);
            });

            if (this.selectors.cartDataJSON) {
              // Update cart data
              this.selectors.cartDataJSON.items = Array.isArray(response.items)
                ? response.items
                : [...this.selectors.cartDataJSON.items, response];
              this.updateCartDataScript();
            }

            // Ensure the cart drawer is visible
            this.selectors.cart.classList.add(this.classes.active);
          } catch (e) {
            console.error('Error updating cart:', e);
            // If cart update fails, redirect to cart page
            window.location = window.routes.cart_url;
          }
        })
        .catch((e) => {
          console.error(e);
          this.showError('An error occurred while adding to cart. Please try again.');
        })
        .finally(() => {
          this.removeButtonLoadingState(this.selectors.submitButton);

          // Clear sticky button loading state
          if (this.selectors.stickyButton) {
            this.removeButtonLoadingState(this.selectors.stickyButton);
          }
        });
    }

    addButtonLoadingState(button) {
      button.setAttribute('aria-disabled', true);
      button.classList.add(this.classes.loading);
      const loadingSpinner = button.querySelector(`.${this.classes.loadingSpinner}`);
      loadingSpinner?.classList.remove(this.classes.hidden);
    }

    removeButtonLoadingState(button) {
      button.removeAttribute('aria-disabled');
      button.classList.remove(this.classes.loading);
      const loadingSpinner = button.querySelector(`.${this.classes.loadingSpinner}`);
      loadingSpinner?.classList.add(this.classes.hidden);
    }

    updateContent(doc) {
      const newMainProduct = doc.querySelector(`.${this.classes.mainProductComponent}`);
      if (newMainProduct) {
        this.innerHTML = newMainProduct.innerHTML;
      }
    }

    updateCartDataScript() {
      if (this.selectors.cartData) {
        this.selectors.cartData.textContent = JSON.stringify(this.selectors.cartDataJSON);
      }
    }

    formatMoney(cents) {
      const moneyFormat = window.theme?.moneyFormat || '${{amount}}';
      return window.Shopify?.formatMoney(cents, moneyFormat) || `$${(cents / 100).toFixed(2)}`;
    }

    showError(message) {
      this.selectors.errorMessage.textContent = message;
      this.selectors.errors.classList.remove(this.classes.hidden);
      setTimeout(() => {
        this.selectors.errors.classList.add(this.classes.hidden);
      }, 5000);
    }

    setLoadingState() {
      this.classList.add(this.classes.loading);
    }

    clearLoadingState() {
      this.classList.remove(this.classes.loading);
    }

    bindStickyButtonEvents() {
      if (this.selectors.stickyButton) {
        // Remove old event listeners first
        if (this.stickyButtonClickHandler) {
          this.selectors.stickyButton.removeEventListener('click', this.stickyButtonClickHandler);
        }

        // Create new handler and store reference
        this.stickyButtonClickHandler = this.handleStickyButtonClick.bind(this);

        // Add click handler to submit the main form
        this.selectors.stickyButton.addEventListener('click', this.stickyButtonClickHandler);
      } else {
        console.warn('Sticky button not found for event binding');
      }
    }

    handleStickyButtonClick(event) {
      // Prevent default to avoid double submission
      event.preventDefault();
      event.stopPropagation();

      // Trigger the main form submit
      const submitButton = this.selectors.submitButton;

      if (submitButton && !submitButton.hasAttribute('aria-disabled')) {
        submitButton.click();
      }
    }

    disconnectedCallback() {
      // Clean up sticky button event listener
      if (this.selectors.stickyButton && this.stickyButtonClickHandler) {
        this.selectors.stickyButton.removeEventListener('click', this.stickyButtonClickHandler);
      }
    }
  }

  window.customElements.define('wls-main-product', WLSMainProduct);
}
